(function () {
  var SECTION_SELECTOR = '.oddit-section-main-product';

  function initSection(section) {
    initAccordions(section);
    initSizeSelector(section);
    initVariantSwitcher(section);
    initNotifyButtonSync(section);
    initSimilarProducts(section);
    initHeelOptions(section);
    initColorOptions(section);
    initGallery(section);
    initAddToCart(section);
    initAddonsCarousel(section);
    initQuickShop(section);
    initSizeGuideDrawer(section);
    initStickyAtc(section);
  }

  // ---------------------------------------------------------------------------
  // Size guide drawer
  // ---------------------------------------------------------------------------
  function initSizeGuideDrawer(section) {
    if (section.__odditSizeGuideInitialized) return;
    section.__odditSizeGuideInitialized = true;

    var drawer = section.querySelector('[data-size-guide-drawer]');
    if (!drawer) return;

    var triggers = section.querySelectorAll('[data-size-guide-open]');
    if (!triggers.length) return;

    var closeBtn = drawer.querySelector('[data-size-guide-close]');
    var overlay = drawer.querySelector('[data-size-guide-overlay]');
    var panel = drawer.querySelector('.oddit-section-main-product__size-guide-drawer-panel');
    var lastTrigger = null;
    var controller = new AbortController();

    function openDrawer(trigger) {
      lastTrigger = trigger || null;
      drawer.style.display = '';
      void drawer.offsetWidth; // force reflow so the transition runs
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus();
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      // Wait for the close transition to finish before fully hiding.
      window.setTimeout(function () {
        if (!drawer.classList.contains('is-open')) {
          drawer.style.display = 'none';
        }
      }, 200);
      if (lastTrigger && typeof lastTrigger.focus === 'function') {
        lastTrigger.focus();
      }
      lastTrigger = null;
    }

    for (var i = 0; i < triggers.length; i++) {
      (function (trigger) {
        trigger.addEventListener(
          'click',
          function () {
            openDrawer(trigger);
          },
          { signal: controller.signal }
        );
      })(triggers[i]);
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', closeDrawer, { signal: controller.signal });
    }

    if (overlay) {
      overlay.addEventListener('click', closeDrawer, { signal: controller.signal });
    }

    document.addEventListener(
      'keydown',
      function (e) {
        if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
          closeDrawer();
        }
      },
      { signal: controller.signal }
    );

    drawer.addEventListener(
      'keydown',
      function (e) {
        if (e.key !== 'Tab') return;
        if (!drawer.classList.contains('is-open')) return;
        if (!panel) return;
        var focusables = panel.querySelectorAll(
          'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        );
        if (focusables.length === 0) return;
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      },
      { signal: controller.signal }
    );
  }

  function initVariantSwitcher(section) {
    var dataEl = section.querySelector('script[data-oddit-variants]');
    if (!dataEl) return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (err) {
      return;
    }

    var optionNames = data.options || [];
    var variants = data.variants || [];
    if (!optionNames.length || !variants.length) return;

    var atcBtn = section.querySelector('.oddit-section-main-product__add-to-cart');
    var initialId = atcBtn ? Number(atcBtn.getAttribute('data-variant-id')) : null;
    var selectedOptions = {};
    var initialVariant = variants.find(function (v) { return v.id === initialId; });
    if (initialVariant) {
      optionNames.forEach(function (name, idx) {
        var value = initialVariant['option' + (idx + 1)];
        if (value) selectedOptions[name] = value;
      });
    }

    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < optionNames.length; j++) {
          var sel = opts[optionNames[j]];
          if (sel && v['option' + (j + 1)] !== sel) {
            match = false;
            break;
          }
        }
        if (match) return v;
      }
      return null;
    }

    function updateStock(variant) {
      var stock = section.querySelector('[data-stock-status]');
      if (!stock) return;
      var text = stock.querySelector('.oddit-section-main-product__stock-text');
      var inLabel = stock.getAttribute('data-in-stock-label') || 'In Stock';
      var outLabel = stock.getAttribute('data-out-of-stock-label') || 'Out of Stock';
      if (text) text.textContent = variant.available ? inLabel : outLabel;
      stock.classList.toggle('oddit-section-main-product__stock-status--unavailable', !variant.available);
    }

    function updateAddToCart(variant) {
      if (!atcBtn) return;
      atcBtn.setAttribute('data-variant-id', variant.id);
      atcBtn.disabled = !variant.available;

      var label;
      if (variant.available) {
        var btnLabel = atcBtn.getAttribute('data-button-label') || 'Add to Cart';
        var showPrice = atcBtn.getAttribute('data-show-price') === 'true';
        label = btnLabel;
        if (showPrice && variant.price) {
          label += ' • ' + variant.price;
        }
      } else {
        label = atcBtn.getAttribute('data-sold-out-label') || 'Sold out';
      }
      atcBtn.textContent = label;
    }

    function updateBuyNowForm(variant) {
      var input = section.querySelector('[data-buy-now-variant-input]');
      if (input) input.value = variant.id;
    }

    function updateStickyAtc(variant) {
      var stickyBtn = section.querySelector('[data-sticky-atc-button]');
      if (stickyBtn) {
        stickyBtn.setAttribute('data-variant-id', variant.id);
        stickyBtn.disabled = !variant.available;
      }
      var priceEl = section.querySelector('[data-sticky-price]');
      if (priceEl && variant.price) {
        priceEl.textContent = variant.price;
      }
    }

    function updateUrl(variant) {
      if (!window.history || !window.history.replaceState) return;
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch (err) {
        /* no-op */
      }
    }

    function broadcastVariantChange() {
      var evt;
      try {
        evt = new Event('change', { bubbles: true });
      } catch (err) {
        evt = document.createEvent('Event');
        evt.initEvent('change', true, false);
      }
      var input = section.querySelector('[data-buy-now-variant-input]');
      if (input) {
        input.dispatchEvent(evt);
      } else {
        document.dispatchEvent(evt);
      }
    }

    var sizes = section.querySelectorAll(
      '.oddit-section-main-product__variants .oddit-section-main-product__size'
    );

    function isValueAvailable(name, value) {
      var idx = optionNames.indexOf(name);
      if (idx === -1) return true;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (!v.available) continue;
        var match = true;
        for (var j = 0; j < optionNames.length; j++) {
          var expected = j === idx ? value : selectedOptions[optionNames[j]];
          if (expected && v['option' + (j + 1)] !== expected) {
            match = false;
            break;
          }
        }
        if (match) return true;
      }
      return false;
    }

    function updateOptionAvailability() {
      for (var i = 0; i < sizes.length; i++) {
        var btn = sizes[i];
        var name = btn.getAttribute('data-option-name');
        if (!name) continue;
        var available = isValueAvailable(name, btn.getAttribute('data-option-value'));
        btn.classList.toggle('oddit-section-main-product__size--unavailable', !available);
        btn.setAttribute('data-available', available ? 'true' : 'false');
        if (available) {
          btn.removeAttribute('aria-label');
        }
      }
    }

    for (var i = 0; i < sizes.length; i++) {
      sizes[i].addEventListener('click', function () {
        var name = this.getAttribute('data-option-name');
        var value = this.getAttribute('data-option-value');
        if (!name) return;

        selectedOptions[name] = value;
        updateOptionAvailability();

        var variant = findVariant(selectedOptions);
        if (!variant) return;

        updateStock(variant);
        updateAddToCart(variant);
        updateBuyNowForm(variant);
        updateStickyAtc(variant);
        updateUrl(variant);
        broadcastVariantChange();
      });
    }

    updateOptionAvailability();
  }

  function initNotifyButtonSync(section) {
    if (!window.MutationObserver) return;

    var cta = section.querySelector('.oddit-section-main-product__cta');
    if (!cta) return;

    var atcBtn = cta.querySelector('.oddit-section-main-product__add-to-cart');
    if (!atcBtn) return;

    var ACTIVE_CLASS = 'oddit-section-main-product__cta--notify-active';
    var notifyBtn = null;

    function isVisible(el) {
      if (!el) return false;
      return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
    }

    function sync() {
      var active = atcBtn.disabled && isVisible(notifyBtn);
      cta.classList.toggle(ACTIVE_CLASS, active);
    }

    function bind(el) {
      notifyBtn = el;
      sync();
      new MutationObserver(sync).observe(el, {
        attributes: true,
        attributeFilter: ['style', 'class']
      });
    }

    var existing = cta.querySelector('#SI_trigger');
    if (existing) {
      bind(existing);
    } else {
      var pending = new MutationObserver(function () {
        var el = cta.querySelector('#SI_trigger');
        if (!el) return;
        pending.disconnect();
        bind(el);
      });
      pending.observe(cta, { childList: true, subtree: true });
    }

    new MutationObserver(function () {
      window.setTimeout(sync, 60);
    }).observe(atcBtn, { attributes: true, attributeFilter: ['disabled'] });
  }

  function initSimilarProducts(section) {
    var container = section.querySelector('[data-similar-products]');
    var dataEl = section.querySelector('script[data-oddit-similar-products]');
    if (!container || !dataEl) return;

    var atcBtn = section.querySelector('.oddit-section-main-product__add-to-cart');
    if (!atcBtn) return;

    var products;
    try {
      products = JSON.parse(dataEl.textContent);
    } catch (err) {
      return;
    }
    if (!products || !products.length) return;

    var heading = container.getAttribute('data-heading') || '';
    var sizePrefix = container.getAttribute('data-size-prefix') || '';

    function variantMatches(variant, value) {
      if (variant.title === value) return true;
      var options = variant.options || [];
      for (var i = 0; i < options.length; i++) {
        if (options[i] === value) return true;
      }
      return false;
    }

    function matchesFor(value) {
      var matches = [];
      for (var i = 0; i < products.length; i++) {
        var variants = products[i].variants || [];
        for (var j = 0; j < variants.length; j++) {
          if (variantMatches(variants[j], value)) {
            matches.push({ product: products[i], url: variants[j].url });
            break;
          }
        }
      }
      return matches;
    }

    function styled(tag, styles, text) {
      var el = document.createElement(tag);
      el.style.cssText = styles;
      if (text != null) el.textContent = text;
      return el;
    }

    function render(value) {
      var matches = matchesFor(value);
      if (!matches.length) {
        clear();
        return;
      }

      container.textContent = '';
      container.setAttribute('data-value', value);

      container.appendChild(
        styled(
          'h3',
          'letter-spacing:0.1px;text-transform:uppercase;color:#000;font-size:14px;font-weight:700;margin:0 0 2px;',
          heading
        )
      );
      container.appendChild(
        styled(
          'h3',
          'letter-spacing:0.1px;text-transform:uppercase;color:#ffd0d3;font-size:14px;font-weight:700;margin:0 0 8px;',
          sizePrefix + value
        )
      );

      var list = styled('ul', 'list-style:none;display:flex;flex-wrap:wrap;padding:0;margin:0;');

      for (var i = 0; i < matches.length; i++) {
        var match = matches[i];
        var item = styled('li', 'width:50%;padding:15px 5px;box-sizing:border-box;');
        var card = styled('div', 'border:1px solid #ccc;height:100%;');

        var link = document.createElement('a');
        link.href = match.url;
        link.style.cssText = 'display:block;text-decoration:none;color:inherit;';

        if (match.product.image) {
          var img = document.createElement('img');
          img.src = match.product.image;
          img.alt = match.product.title || '';
          img.loading = 'lazy';
          img.style.cssText = 'width:100%;display:block;';
          link.appendChild(img);
        }

        link.appendChild(
          styled('p', 'padding:5px;margin:0;font-size:13px;', match.product.title || '')
        );
        link.appendChild(
          styled('div', 'padding:0 5px 5px;font-size:13px;', match.product.price || '')
        );

        card.appendChild(link);
        item.appendChild(card);
        list.appendChild(item);
      }

      container.appendChild(list);
    }

    function clear() {
      container.textContent = '';
      container.removeAttribute('data-value');
      container.hidden = true;
    }

    function injectIntoPopup() {
      var frame = document.getElementById('SI_frame');
      if (!frame) return;

      var doc;
      try {
        doc = frame.contentDocument || frame.contentWindow.document;
      } catch (err) {
        return;
      }
      if (!doc) return;

      var target = doc.getElementById('container') || doc.body;
      if (!target) return;

      var existing = target.querySelector('[data-similar-clone]');
      var value = container.getAttribute('data-value');

      if (!value) {
        if (existing) existing.parentNode.removeChild(existing);
        return;
      }

      if (existing && existing.getAttribute('data-value') === value) return;
      if (existing) existing.parentNode.removeChild(existing);

      var clone = container.cloneNode(true);
      clone.hidden = false;
      clone.removeAttribute('hidden');
      clone.setAttribute('data-similar-clone', '');
      clone.style.cssText = 'display:block;padding:0 20px 20px;';
      target.appendChild(clone);
    }

    document.addEventListener('click', function (e) {
      var node = e.target;
      if (!node || !node.closest || !node.closest('#SI_trigger')) return;
      var attempts = 0;
      var timer = window.setInterval(function () {
        attempts++;
        injectIntoPopup();
        if (attempts > 14) window.clearInterval(timer);
      }, 150);
    });

    var sizes = section.querySelectorAll(
      '.oddit-section-main-product__variants .oddit-section-main-product__size'
    );

    for (var i = 0; i < sizes.length; i++) {
      sizes[i].addEventListener('click', function () {
        var value = this.getAttribute('data-option-value');
        window.setTimeout(function () {
          if (atcBtn.disabled) {
            render(value);
          } else {
            clear();
          }
        }, 0);
      });
    }

    if (atcBtn.disabled) {
      var active = section.querySelector(
        '.oddit-section-main-product__variants .oddit-section-main-product__size--active'
      );
      if (active) render(active.getAttribute('data-option-value'));
    }
  }

  function initAccordions(section) {
    var accordions = section.querySelectorAll('.oddit-section-main-product__accordion');
    for (var i = 0; i < accordions.length; i++) {
      var accordion = accordions[i];
      var summary = accordion.querySelector('.oddit-section-main-product__accordion-header');
      if (summary) {
        summary.addEventListener('click', function (e) {
          /* Native <details> handles toggle */
        });
      }
    }
  }

  function initSizeSelector(section) {
    var sizes = section.querySelectorAll(
      '.oddit-section-main-product__variants .oddit-section-main-product__size'
    );

    for (var i = 0; i < sizes.length; i++) {
      sizes[i].addEventListener('click', function () {
        var group = this.closest('.oddit-section-main-product__variant-group');
        var groupSizes = group
          ? group.querySelectorAll('.oddit-section-main-product__size')
          : sizes;

        for (var j = 0; j < groupSizes.length; j++) {
          groupSizes[j].classList.remove('oddit-section-main-product__size--active');
          groupSizes[j].setAttribute('aria-pressed', 'false');
        }
        this.classList.add('oddit-section-main-product__size--active');
        this.setAttribute('aria-pressed', 'true');

        var label = group && group.querySelector('.oddit-section-main-product__variant-label strong');
        if (label) {
          label.textContent = this.textContent.trim();
        }

        var stickySize = section.querySelector('[data-sticky-size]');
        if (stickySize) {
          stickySize.textContent = this.textContent.trim();
          var stickySizeWrap = section.querySelector('[data-sticky-size-wrap]');
          if (stickySizeWrap) stickySizeWrap.hidden = false;
        }
      });
    }
  }

  function initHeelOptions(section) {
    var options = section.querySelectorAll('.oddit-section-main-product__heel-option');

    for (var i = 0; i < options.length; i++) {
      options[i].addEventListener('click', function () {
        for (var j = 0; j < options.length; j++) {
          options[j].classList.remove('oddit-section-main-product__heel-option--active');
          options[j].setAttribute('aria-pressed', 'false');
        }
        this.classList.add('oddit-section-main-product__heel-option--active');
        this.setAttribute('aria-pressed', 'true');
      });
    }
  }

  function initColorOptions(section) {
    var options = section.querySelectorAll(
      '.oddit-section-main-product__variants .oddit-section-main-product__color-option'
    );

    for (var i = 0; i < options.length; i++) {
      options[i].addEventListener('click', function () {
        for (var j = 0; j < options.length; j++) {
          options[j].classList.remove('oddit-section-main-product__color-option--active');
          options[j].setAttribute('aria-pressed', 'false');
          var innerSwatch = options[j].querySelector('.oddit-color-swatch');
          if (innerSwatch) {
            innerSwatch.classList.remove('oddit-color-swatch--active');
            innerSwatch.removeAttribute('aria-current');
          }
        }
        this.classList.add('oddit-section-main-product__color-option--active');
        this.setAttribute('aria-pressed', 'true');
        var thisSwatch = this.querySelector('.oddit-color-swatch');
        if (thisSwatch) {
          thisSwatch.classList.add('oddit-color-swatch--active');
          thisSwatch.setAttribute('aria-current', 'true');
        }
      });
    }
  }

  function initGallery(section) {
    var wrap = section.querySelector('.oddit-section-main-product__main-image-wrap');
    var mainImages = section.querySelectorAll('.oddit-section-main-product__main-image');
    var thumbnails = section.querySelectorAll('.oddit-section-main-product__thumbnail');
    var dots = section.querySelectorAll('.oddit-section-main-product__gallery-dot');
    if (!mainImages.length) return;

    var soundEnabled = false;

    function syncSoundToggle(slide, video) {
      var toggle = slide.querySelector('[data-video-sound]');
      if (!toggle) return;
      var on = !video.muted;
      var label = on
        ? toggle.getAttribute('data-sound-on-label') || 'Mute video'
        : toggle.getAttribute('data-sound-off-label') || 'Tap for sound';
      toggle.classList.toggle('oddit-section-main-product__video-sound--on', on);
      toggle.setAttribute('aria-pressed', on ? 'true' : 'false');
      toggle.setAttribute('aria-label', label);
      var text = toggle.querySelector('[data-video-sound-label]');
      if (text) text.textContent = label;
    }

    function applySound(video, slide) {
      video.muted = !soundEnabled;
      if (soundEnabled) video.volume = 1;
      syncSoundToggle(slide, video);
    }

    var soundToggles = section.querySelectorAll('[data-video-sound]');
    for (var s = 0; s < soundToggles.length; s++) {
      soundToggles[s].addEventListener('click', function (e) {
        e.stopPropagation();
        var slide = this.closest('.oddit-section-main-product__main-image');
        var video = slide ? slide.querySelector('video') : null;
        if (!video) return;

        soundEnabled = video.muted;
        video.muted = !soundEnabled;
        if (soundEnabled) video.volume = 1;

        for (var i = 0; i < mainImages.length; i++) {
          var other = mainImages[i].querySelector('video');
          if (other && other !== video) {
            other.muted = true;
            syncSoundToggle(mainImages[i], other);
          }
        }
        syncSoundToggle(slide, video);

        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {
            video.muted = true;
            soundEnabled = false;
            syncSoundToggle(slide, video);
          });
        }
      });
    }

    function setActive(index) {
      if (index < 0 || index >= mainImages.length) return;
      for (var i = 0; i < mainImages.length; i++) {
        var isActive = i === index;
        mainImages[i].classList.toggle('oddit-section-main-product__main-image--active', isActive);
        var video = mainImages[i].querySelector('video');
        if (video) {
          if (isActive) {
            applySound(video, mainImages[i]);
            var playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              (function (v, slide) {
                playPromise.catch(function () {
                  if (v.muted) return;
                  v.muted = true;
                  soundEnabled = false;
                  syncSoundToggle(slide, v);
                  var retry = v.play();
                  if (retry && typeof retry.catch === 'function') retry.catch(function () {});
                });
              })(video, mainImages[i]);
            }
          } else {
            video.pause();
            video.currentTime = 0;
            video.muted = true;
            syncSoundToggle(mainImages[i], video);
          }
        }
      }
      for (var i = 0; i < thumbnails.length; i++) {
        thumbnails[i].classList.toggle('oddit-section-main-product__thumbnail--active', i === index);
      }
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('oddit-section-main-product__gallery-dot--active', i === index);
      }
    }

    for (var i = 0; i < thumbnails.length; i++) {
      (function (idx) {
        thumbnails[idx].addEventListener('click', function () {
          setActive(idx);
          if (wrap && wrap.scrollWidth > wrap.clientWidth) {
            var target = mainImages[idx];
            if (target) {
              wrap.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
            }
          }
        });
      })(i);
    }

    if (wrap) {
      var scrollTimer = null;
      wrap.addEventListener('scroll', function () {
        if (scrollTimer) cancelAnimationFrame(scrollTimer);
        scrollTimer = requestAnimationFrame(function () {
          if (wrap.scrollWidth <= wrap.clientWidth) return;
          var center = wrap.scrollLeft + wrap.clientWidth / 2;
          var nearest = 0;
          var nearestDist = Infinity;
          for (var i = 0; i < mainImages.length; i++) {
            var img = mainImages[i];
            var imgCenter = img.offsetLeft + img.offsetWidth / 2;
            var dist = Math.abs(imgCenter - center);
            if (dist < nearestDist) {
              nearestDist = dist;
              nearest = i;
            }
          }
          setActive(nearest);
        });
      });
    }

    var thumbsScroll = section.querySelector('.oddit-section-main-product__thumbnails');
    if (thumbsScroll) {
      var THUMBS_DRAG_CLASS = 'oddit-section-main-product__thumbnails--dragging';
      var THUMBS_DRAG_THRESHOLD = 5;
      var thumbsPointerDown = false;
      var thumbsDidDrag = false;
      var thumbsStartX = 0;
      var thumbsStartScrollLeft = 0;

      thumbsScroll.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        thumbsPointerDown = true;
        thumbsDidDrag = false;
        thumbsStartX = e.clientX;
        thumbsStartScrollLeft = thumbsScroll.scrollLeft;
      });

      thumbsScroll.addEventListener('pointermove', function (e) {
        if (!thumbsPointerDown) return;
        var dx = e.clientX - thumbsStartX;
        if (!thumbsDidDrag && Math.abs(dx) > THUMBS_DRAG_THRESHOLD) {
          thumbsDidDrag = true;
          thumbsScroll.classList.add(THUMBS_DRAG_CLASS);
          try { thumbsScroll.setPointerCapture(e.pointerId); } catch (err) {}
        }
        if (thumbsDidDrag) {
          e.preventDefault();
          thumbsScroll.scrollLeft = thumbsStartScrollLeft - dx;
        }
      });

      function endThumbsDrag() {
        if (!thumbsPointerDown) return;
        thumbsPointerDown = false;
        if (thumbsDidDrag) {
          thumbsScroll.classList.remove(THUMBS_DRAG_CLASS);
        }
      }

      thumbsScroll.addEventListener('pointerup', endThumbsDrag);
      thumbsScroll.addEventListener('pointercancel', endThumbsDrag);
      thumbsScroll.addEventListener('pointerleave', endThumbsDrag);

      thumbsScroll.addEventListener('click', function (e) {
        if (thumbsDidDrag) {
          e.preventDefault();
          e.stopPropagation();
          thumbsDidDrag = false;
        }
      }, true);

      thumbsScroll.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });
    }

    var initialIndex = 0;
    for (var i = 0; i < mainImages.length; i++) {
      if (mainImages[i].classList.contains('oddit-section-main-product__main-image--active')) {
        initialIndex = i;
        break;
      }
    }
    setActive(initialIndex);
  }

  function initAddonsCarousel(section) {
    var scroll = section.querySelector('.oddit-section-main-product__addons-scroll');
    if (!scroll) return;

    var cards = scroll.querySelectorAll('.oddit-section-main-product__addon-card');
    var dots = section.querySelectorAll('.oddit-section-main-product__addons-dot');

    var DRAG_CLASS = 'is-dragging';
    var DRAG_THRESHOLD = 5;
    var isPointerDown = false;
    var didDrag = false;
    var startX = 0;
    var startScrollLeft = 0;

    scroll.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      isPointerDown = true;
      didDrag = false;
      startX = e.clientX;
      startScrollLeft = scroll.scrollLeft;
    });

    scroll.addEventListener('pointermove', function (e) {
      if (!isPointerDown) return;
      var dx = e.clientX - startX;
      if (!didDrag && Math.abs(dx) > DRAG_THRESHOLD) {
        didDrag = true;
        scroll.classList.add(DRAG_CLASS);
        try { scroll.setPointerCapture(e.pointerId); } catch (err) {}
      }
      if (didDrag) {
        e.preventDefault();
        scroll.scrollLeft = startScrollLeft - dx;
      }
    });

    function endDrag(e) {
      if (!isPointerDown) return;
      isPointerDown = false;
      if (didDrag) {
        scroll.classList.remove(DRAG_CLASS);
      }
    }

    scroll.addEventListener('pointerup', endDrag);
    scroll.addEventListener('pointercancel', endDrag);
    scroll.addEventListener('pointerleave', endDrag);

    scroll.addEventListener('click', function (e) {
      if (didDrag) {
        e.preventDefault();
        e.stopPropagation();
        didDrag = false;
      }
    }, true);

    scroll.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });

    function getCardLeftWithinScroll(card) {
      return card.getBoundingClientRect().left
        - scroll.getBoundingClientRect().left
        + scroll.scrollLeft;
    }

    function getNearestIndex() {
      if (!cards.length) return 0;
      var viewportCenter = scroll.scrollLeft + scroll.clientWidth / 2;
      var nearest = 0;
      var nearestDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var center = getCardLeftWithinScroll(cards[i]) + cards[i].offsetWidth / 2;
        var dist = Math.abs(center - viewportCenter);
        if (dist < nearestDist) {
          nearestDist = dist;
          nearest = i;
        }
      }
      return nearest;
    }

    function scrollToIndex(index, smooth) {
      if (!cards[index]) return;
      var scrollPaddingLeft = parseFloat(getComputedStyle(scroll).scrollPaddingLeft) || 0;
      var target = getCardLeftWithinScroll(cards[index]) - scrollPaddingLeft;
      scroll.scrollTo({ left: target, behavior: smooth ? 'smooth' : 'auto' });
    }

    function updateActiveDot() {
      var idx = getNearestIndex();
      for (var i = 0; i < dots.length; i++) {
        if (i === idx) {
          dots[i].classList.add('oddit-section-main-product__addons-dot--active');
        } else {
          dots[i].classList.remove('oddit-section-main-product__addons-dot--active');
        }
      }
    }

    var scrollTimer = null;
    scroll.addEventListener('scroll', function () {
      if (scrollTimer) cancelAnimationFrame(scrollTimer);
      scrollTimer = requestAnimationFrame(updateActiveDot);
    });

    for (var i = 0; i < dots.length; i++) {
      (function (idx) {
        dots[idx].addEventListener('click', function () {
          scrollToIndex(idx, true);
        });
      })(i);
    }
  }

  function initQuickShop(section) {
    var triggers = section.querySelectorAll('[data-quick-shop-open]');
    if (!triggers.length) return;

    function getShoeSizeValue() {
      var active = section.querySelector(
        '.oddit-section-main-product__variants .oddit-section-main-product__size--active'
      );
      return active ? active.getAttribute('data-option-value') : null;
    }

    function sizeNumber(str) {
      if (!str) return null;
      var m = String(str).match(/\d+(\.\d+)?/);
      return m ? parseFloat(m[0]) : null;
    }

    function valueContainsSize(value, shoeNum) {
      if (shoeNum == null) return false;
      var tokens = String(value).match(/\d+(\.\d+)?/g);
      if (!tokens) return false;
      for (var i = 0; i < tokens.length; i++) {
        if (parseFloat(tokens[i]) === shoeNum) return true;
      }
      return false;
    }

    function setupModal(modal) {
      if (modal.__odditQuickShopInit) return;
      modal.__odditQuickShopInit = true;

      var dataEl = modal.querySelector('script[data-quick-shop-variants]');
      var data = {};
      if (dataEl) {
        try { data = JSON.parse(dataEl.textContent); } catch (err) { data = {}; }
      }
      var optionNames = data.options || [];
      var variants = data.variants || [];

      var addBtn = modal.querySelector('[data-quick-shop-add]');
      var priceEl = modal.querySelector('[data-quick-shop-price]');
      var optionBtns = modal.querySelectorAll('[data-quick-shop-option]');
      var labels = modal.querySelectorAll('[data-quick-shop-option-label]');
      var overlay = modal.querySelector('[data-quick-shop-overlay]');
      var closeBtn = modal.querySelector('[data-quick-shop-close]');
      var panel = modal.querySelector('.oddit-section-main-product__quick-shop-panel');

      var selected = {};

      function findVariant() {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var match = true;
          for (var j = 0; j < optionNames.length; j++) {
            var sel = selected[optionNames[j]];
            if (sel != null && v['option' + (j + 1)] !== sel) {
              match = false;
              break;
            }
          }
          if (match) return v;
        }
        return null;
      }

      function isValueAvailable(name, value) {
        var idx = optionNames.indexOf(name);
        if (idx === -1) return true;
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          if (!v.available) continue;
          var match = true;
          for (var j = 0; j < optionNames.length; j++) {
            var expected = j === idx ? value : selected[optionNames[j]];
            if (expected && v['option' + (j + 1)] !== expected) {
              match = false;
              break;
            }
          }
          if (match) return true;
        }
        return false;
      }

      function updateActiveStates() {
        for (var i = 0; i < optionBtns.length; i++) {
          var btn = optionBtns[i];
          var isActive = selected[btn.getAttribute('data-option-name')] === btn.getAttribute('data-option-value');
          var isAvailable = isValueAvailable(
            btn.getAttribute('data-option-name'),
            btn.getAttribute('data-option-value')
          );
          btn.setAttribute('data-available', isAvailable ? 'true' : 'false');
          if (btn.classList.contains('oddit-section-main-product__color-option')) {
            btn.classList.toggle('oddit-section-main-product__color-option--active', isActive);
            var swatch = btn.querySelector('.oddit-color-swatch');
            if (swatch) {
              swatch.classList.toggle('oddit-color-swatch--active', isActive);
              if (isActive) {
                swatch.setAttribute('aria-current', 'true');
              } else {
                swatch.removeAttribute('aria-current');
              }
            }
          } else {
            btn.classList.toggle('oddit-section-main-product__size--active', isActive);
            btn.classList.toggle('oddit-section-main-product__size--unavailable', !isAvailable);
            btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          }
        }
        for (var k = 0; k < labels.length; k++) {
          var name = labels[k].getAttribute('data-quick-shop-option-label');
          labels[k].textContent = selected[name] || '';
        }
      }

      function update() {
        updateActiveStates();
        var variant = findVariant();
        if (variant) {
          if (priceEl && variant.price) priceEl.textContent = variant.price;
          if (addBtn) {
            addBtn.setAttribute('data-variant-id', variant.id);
            addBtn.disabled = !variant.available;
            addBtn.textContent = variant.available
              ? (addBtn.getAttribute('data-button-label') || 'Add to Cart')
              : (addBtn.getAttribute('data-sold-out-label') || 'Sold out');
          }
        } else if (addBtn) {
          addBtn.disabled = true;
          addBtn.textContent = addBtn.getAttribute('data-sold-out-label') || 'Unavailable';
        }
      }

      for (var b = 0; b < optionBtns.length; b++) {
        optionBtns[b].addEventListener('click', function () {
          var name = this.getAttribute('data-option-name');
          if (!name) return;
          selected[name] = this.getAttribute('data-option-value');
          update();
        });
      }

      var initVariant = null;
      for (var v = 0; v < variants.length; v++) {
        if (variants[v].available) { initVariant = variants[v]; break; }
      }
      if (!initVariant && variants.length) initVariant = variants[0];

      function resetToInitial() {
        selected = {};
        if (initVariant) {
          for (var idx = 0; idx < optionNames.length; idx++) {
            selected[optionNames[idx]] = initVariant['option' + (idx + 1)];
          }
        }
      }

      function preselectSize(shoeSizeValue) {
        var shoeNum = sizeNumber(shoeSizeValue);
        if (shoeNum == null) return;
        var sizeIdx = -1;
        for (var i = 0; i < optionNames.length; i++) {
          if (String(optionNames[i]).toLowerCase().indexOf('size') !== -1) {
            sizeIdx = i;
            break;
          }
        }
        if (sizeIdx === -1) return;
        var key = 'option' + (sizeIdx + 1);
        var matchAvailable = null;
        var matchAny = null;
        for (var j = 0; j < variants.length; j++) {
          if (valueContainsSize(variants[j][key], shoeNum)) {
            if (variants[j].available && matchAvailable == null) matchAvailable = variants[j];
            if (matchAny == null) matchAny = variants[j];
          }
        }
        var pick = matchAvailable || matchAny;
        if (!pick) return;
        // Snap to the matched variant's full option set so size+color stays a real,
        // addable combination rather than an unavailable mix with the default color.
        for (var idx = 0; idx < optionNames.length; idx++) {
          selected[optionNames[idx]] = pick['option' + (idx + 1)];
        }
      }

      var lastTrigger = null;

      function openModal(trigger) {
        lastTrigger = trigger || null;
        resetToInitial();
        preselectSize(getShoeSizeValue());
        update();
        modal.style.display = '';
        void modal.offsetWidth;
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        if (closeBtn) closeBtn.focus();
      }

      function closeModal() {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        window.setTimeout(function () {
          if (!modal.classList.contains('is-open')) {
            modal.style.display = 'none';
          }
        }, 200);
        if (lastTrigger && typeof lastTrigger.focus === 'function') {
          lastTrigger.focus();
        }
        lastTrigger = null;
      }

      modal.__odditQuickShopOpen = openModal;
      modal.__odditQuickShopClose = closeModal;

      if (closeBtn) closeBtn.addEventListener('click', closeModal);
      if (overlay) overlay.addEventListener('click', closeModal);
      if (addBtn) addBtn.addEventListener('click', closeModal);

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) {
          closeModal();
        }
      });

      modal.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        if (!modal.classList.contains('is-open') || !panel) return;
        var focusables = panel.querySelectorAll(
          'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        );
        if (!focusables.length) return;
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      });
    }

    for (var t = 0; t < triggers.length; t++) {
      (function (trigger) {
        trigger.addEventListener('click', function () {
          var targetId = trigger.getAttribute('data-quick-shop-target');
          var modal = targetId ? document.getElementById(targetId) : null;
          if (!modal) return;
          setupModal(modal);
          if (typeof modal.__odditQuickShopOpen === 'function') {
            modal.__odditQuickShopOpen(trigger);
          }
        });
      })(triggers[t]);
    }
  }

  function initStickyAtc(section) {
    var sticky = section.querySelector('[data-sticky-atc]');
    var mainAtc = section.querySelector('.oddit-section-main-product__add-to-cart');
    if (!sticky || !mainAtc || typeof IntersectionObserver !== 'function') return;

    var scrolledPastMain = false;
    var footerInView = false;

    function update() {
      var visible = scrolledPastMain && !footerInView;
      sticky.classList.toggle('is-visible', visible);
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    var mainObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        scrolledPastMain = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      });
      update();
    }, { threshold: 0 });
    mainObserver.observe(mainAtc);

    var footer = document.querySelector('.oddit-footer-main');
    if (footer) {
      var footerObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          footerInView = entry.isIntersecting;
        });
        update();
      }, { threshold: 0 });
      footerObserver.observe(footer);
    }
  }

  function initAddToCart(section) {
    section.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-add-to-cart]');
      if (!btn) return;

      if (window.OdditCartDrawer) {
        var variantId = Number(btn.getAttribute('data-variant-id'));
        if (!variantId) return;

        var quantity = Number(btn.getAttribute('data-quantity')) || 1;
        btn.disabled = true;

        window.OdditCartDrawer.addToCart(variantId, quantity)
          .then(function () {
            window.OdditCartDrawer.open();
          })
          .finally(function () {
            btn.disabled = false;
          });
      }
    });
  }

  /* Init all instances on page */
  var sections = document.querySelectorAll(SECTION_SELECTOR);
  for (var i = 0; i < sections.length; i++) {
    initSection(sections[i]);
  }

  /* Shopify theme editor support */
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });
})();